import { render, staticRenderFns } from "./permission-manager.vue?vue&type=template&id=6b0a4ae0&scoped=true"
import script from "./permission-manager.ts?vue&type=script&lang=ts&external"
export * from "./permission-manager.ts?vue&type=script&lang=ts&external"
import style0 from "./permission-manager.less?vue&type=style&index=0&id=6b0a4ae0&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0a4ae0",
  null
  
)

export default component.exports